<template>
  <div class="container">
    <div class="menu-operation">
      <div class="menu-operation-item">
        <div class="four-font-wrapper" style="margin-right: 1vw" @click="showAddModal(1)"><div class="icon-font">&#xe605;</div>添加角色</div>
        <div class="four-font-wrapper" style="margin-right: 1vw" @click="deleteAll"><div class="icon-font">&#xe646;</div>批量删除</div>
<!--        <div class="four-font-wrapper"><div class="icon-font">&#xe60e;</div>权限配置</div>-->
      </div>
      <div class="menu-operation-item">
        <div class="input-wrapper" style="margin-right: 1vw">
          <input placeholder="请输入关键字" v-model="search.value"/>
        </div>
        <div class="query button" @click="handleSearch(true)">查询</div>
      </div>
    </div>
    <div class="detail">
      <div class="detail-box">
        <div class="detail-nav">
          <div class="detail-item" style="width: 10%">
            <div class="select-icon" :class="{'select-icon-active': all}" @click="selectAll"></div>
          </div>
          <div class="detail-item" style="width: 15%">名称</div>
          <div class="detail-item" style="width: 15%">上级角色</div>
          <div class="detail-item" style="width: 15%">所在部门</div>
          <div class="detail-item" style="width: 15%">别名</div>
          <div class="detail-item" style="width: 30%">操作</div>
        </div>
        <div class="detail-content" v-if="!loading">
          <div class="detail-list-wrapper" v-for="(data,index) in tableData" :key="index">
            <div class="detail-item" style="width: 10%" >
              <div class="select-icon" :class="{'select-icon-active': data.sign === 1}" @click="selectSingle(data.id)"></div>
            </div>
            <div class="detail-item" style="width: 15%">{{data.name}}</div>
            <div class="detail-item" style="width: 15%">{{data.pidName}}</div>
            <div class="detail-item" style="width: 15%">{{data.deptName || '--'}}</div>
            <div class="detail-item" style="width: 15%">{{data.tips}}</div>
            <div class="detail-item" style="width: 30%">
              <div class="detail-btn item-look" @click="showAddModal(2, data)">修改</div>
              <div class="detail-btn item-audit" style="margin: 0 0.5vw" @click="showAddModal(3, data)">权限配置</div>
              <div class="detail-btn item-delete" @click="deleteSingle(data.id)">删除</div>
            </div>
          </div>
          <div class="none-data" v-if="!loading && tableData.length<1">暂无数据</div>
        </div>
        <div class="page-wrapper" v-if="!loading && total > rows">
          <div class="page-wrapper-left">共{{total}}条数据，每页显示{{rows}}条，当前第{{page}}页</div>
          <div class="page-wrapper-right">
            <div class="page-btn" @click="firstPage">首页</div>
            <div class="page-btn" @click="previousPage">上一页</div>
            <div class="page-btn" @click="nextPage">下一页</div>
            <div class="page-btn" @click="lastPage">尾页</div>
          </div>
        </div>
        <div class="loading-data" v-if="loading">
          <i class="el-icon-loading"></i>
          <div>加载中，请稍后···</div>
        </div>
      </div>
      <transition name="fade">
        <div class="alert-box" v-if="show">
          <div class="alert-content">
            <div class="alert-content-title">删除提醒</div>
            <div class="alert-content-msg">是否确认删除选中数据?</div>
            <div class="alert-content-btn">
              <div class="btn-cancel button" @click="cancelDelete">取消</div>
              <div class="btn-confirm button" @click="confirmDelete">确认</div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <transition name="fade">
      <div class="alert-box" v-if="showAdd">
        <div class="alert-content" style="width: auto;padding: 1vw 2vw">
          <div class="alert-content-title">{{rType === 1 ? '添加角色' : rType=== 2 ? '修改角色' : '权限配置'}}</div>
          <div v-if="rType===1 || rType === 2">
            <div class="alert-content-msg" style="width: 100%;flex-direction: column">
              <div class="alert-list">
                <div class="input-contain" style="margin-right: 2vw">
                  <div class="input-title">角色名称：</div>
                  <div class="input-wrapper">
                    <input placeholder="" v-model="item.name"/>
                  </div>
                </div>
                <div class="input-contain">
                  <div class="input-title" style="padding-left: 1.78vw">别名：</div>
                  <div class="input-wrapper">
                    <input placeholder="" v-model="item.tips"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="alert-content-msg" style="width: 100%;flex-direction: column;position: relative;z-index: 9999">
              <div class="alert-list">
                <div class="input-contain" style="margin-right: 2vw">
                  <div class="input-title">上级名称：</div>
                  <TreeSingle :content="superiorR" :editCheckId="superiorRId" :items="roleData" v-on:sendInfo = "showInfo"></TreeSingle>
                </div>
                <div class="input-contain">
                  <div class="input-title" style="padding-left: 1.78vw">排序：</div>
                  <div class="input-wrapper">
                    <input placeholder="" v-model="item.num"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="alert-content-msg" style="width: 100%;flex-direction: column">
              <div class="alert-list">
                <div class="input-contain" style="margin-right: 2vw">
                  <div class="input-title">部门名称：</div>
                  <TreeSingle :content="atD" :editCheckId="atDId" :items="departmentData" v-on:sendInfo = "showDropInfo"></TreeSingle>
                </div>
              </div>
            </div>
          </div>
          <div v-if="rType === 3" style="margin-bottom: 1vw">
            <TreeMore have="0" :content="roleTitle" :editCheckId="roleEditCheckId" :items="menuData" v-on:sendInfo = "roleInfo"></TreeMore>
          </div>
          <div class="alert-content-btn">
            <div class="btn-cancel button" @click="cancelAdd">取消</div>
            <div class="btn-confirm button" @click="confirmAdd">确认</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import DropDown from '../../components/DropDownSingle.vue'
import TreeSingle from '../../components/TreeSingle.vue'
import TreeMore from '../../components/TreeMore.vue'
import {flatJson} from '../../tools/methods'
import {roleTree, roleList, deptTree, roleAdd, delRole, delRoleMore, roleUpdate, menuTreeListByRoleId, selectMenuTreeList, setAuthority} from '../../api/system'
export default {
  name: 'Role',
  components: { DropDown, TreeSingle, TreeMore },
  data () {
    return {
      roleTitle: '',
      roleEditCheckId: [],
      menuData: [],
      permission: {
        ids: '',
        roleId: ''
      },
      superiorR: '',
      superiorRId: '',
      atD: '',
      atDId: '',
      rType: '',
      search: {
        value: ''
      },
      item: {
        deptid: '',
        id: '',
        name: '',
        num: '',
        pid: '',
        tips: ''
      },
      page: 1,
      rows: 10,
      total: '',
      loading: true,
      showAdd: false,
      show: false,
      all: false,
      id: '',
      type: 0,
      idList: [],
      tableData: [],
      departmentData: [],
      roleData: []
    }
  },
  created () {
    this.getData(false)
  },
  methods: {
    roleInfo: function (data) {
      this.roleEditCheckId = data.checkedKeys
      console.log(data)
    },
    getMenu: function () {
      selectMenuTreeList().then(res => {
        console.log(res)
        this.menuData = [
          res.data
        ]
        console.log(this.menuData)
      }).catch(err => {
        console.log(err)
      })
    },
    getData: function () {
      deptTree().then(res => {
        this.departmentData = [
          {
            id: -1,
            name: '无'
          },
          res.data
        ]
        roleTree().then(res => {
          console.log(res)
          this.roleData = [
            res.data
          ]
          this.handleSearch()
        }).catch(err => {
          console.log(err)
        })
      }).catch(err => {
        console.log(err)
      })
    },
    selectAll: function () {
      this.type = 1
      this.all = !this.all
      let idList = []
      if (this.all) {
        this.tableData.map((data, index) => {
          data.sign = 1
          idList.push(data.id)
        })
        this.idList = idList
      } else {
        this.tableData.map((data, index) => {
          data.sign = 0
          this.idList = []
        })
      }
    },
    selectSingle: function (id) {
      this.tableData.map((data, index) => {
        if (id === data.id) {
          data.sign = data.sign === 1 ? 0 : 1
          if (data.sign === 1) {
            this.idList.push(data.id)
          } else {
            let idList = []
            this.idList.map((item, index) => {
              if (item !== id) {
                idList.push(item)
              }
            })
            this.idList = idList
          }
          console.log(this.idList)
        }
      })
      this.all = this.idList.length === this.tableData.length
    },
    deleteSingle: function (id) {
      this.show = true
      this.id = id
      this.type = 0
    },
    deleteAll: function () {
      if (this.idList.length !== 0) {
        this.show = true
        this.type = 1
      } else {
        this.$message({
          message: '请选择要删除的数据!',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      }
      console.log(this.idList)
    },
    cancelDelete: function () {
      this.show = false
    },
    confirmDelete: function () {
      if (this.type === 0) {
        let body = {
          roleId: this.id
        }
        delRole(body).then(res => {
          console.log(res)
          this.show = false
          this.id = ''
          this.$message({
            message: '删除成功!',
            type: 'success',
            center: 'true',
            duration: '1000'
          })
          this.handleSearch()
        }).catch(err => {
          console.log(err)
        })
      } else {
        let body = {
          roleIdLs: this.idList.join()
        }
        console.log(body)
        delRoleMore(body).then(res => {
          console.log(res)
          this.getData(true)
          this.all = false
          this.idList = []
          this.$message({
            message: '删除成功!',
            type: 'success',
            center: 'true',
            duration: '1000'
          })
          this.show = false
        }).catch(err => {
          console.log(err)
        })
      }
    },
    showAddModal: function (rType, data) {
      this.rType = rType
      if (rType === 1) {
        console.log(this.item)
        this.superiorR = '请选择上级角色'
        this.superiorRId = ''
        this.atD = '请选择所在部门'
        this.atDId = -1
        this.item = {
          deptid: '',
          id: '',
          name: '',
          num: '',
          pid: '',
          tips: ''
        }
        this.showAdd = true
      } else if (rType === 2) {
        this.superiorR = data.pidName
        this.superiorRId = data.pid
        this.atD = data.deptName ? data.deptName : '无'
        this.atDId = data.deptid ? data.deptid : -1
        this.item = {
          deptid: data.deptid,
          id: data.id,
          name: data.name,
          num: data.num,
          pid: data.pid,
          tips: data.tips
        }
        this.showAdd = true
      } else {
        this.getMenu()
        let body = {
          roleId: data.id
        }
        console.log(data)
        menuTreeListByRoleId(body).then(res => {
          console.log(res.data)
          let arr = flatJson(res.data)
          let list = []
          let name = []
          arr.map(data => {
            if (data.checked === true && data.name !== '顶级') {
              list.push(data.id)
              name.push(data.name)
            }
          })
          this.roleEditCheckId = list
          this.roleTitle = name.join()
          this.showAdd = true
        }).catch(err => {
          console.log(err)
        })
        this.permission = {
          ids: [],
          roleId: data.id
        }
      }
    },
    cancelAdd: function () {
      this.showAdd = false
    },
    confirmAdd: function () {
      if (this.rType === 3) {
        this.permission.ids = this.roleEditCheckId.join()
        let body = this.permission
        console.log(body)
        setAuthority(body).then(res => {
          console.log(res)
          this.$message({
            message: '配置成功!',
            type: 'success',
            center: 'true',
            duration: '1000'
          })
          this.showAdd = false
        }).catch(err => {
          console.log(err)
        })
      } else {
        if (this.item.name === '') {
          this.$message({
            message: '请输入角色名称',
            type: 'warning',
            center: 'true',
            duration: '1000'
          })
        } else {
          if (this.item.pid === '') {
            this.$message({
              message: '请选择父角色',
              type: 'warning',
              center: 'true',
              duration: '1000'
            })
          } else {
            if (this.item.tips === '') {
              this.$message({
                message: '请输入别名',
                type: 'warning',
                center: 'true',
                duration: '1000'
              })
            } else {
              console.log(this.item)
              if (this.rType === 1) {
                let body = this.item
                roleAdd(body).then(res => {
                  console.log(res)
                  this.$message({
                    message: '添加成功!',
                    type: 'success',
                    center: 'true',
                    duration: '1000'
                  })
                  this.showAdd = false
                  this.handleSearch()
                }).catch(err => {
                  console.log(err)
                })
              } else {
                let body = this.item
                console.log(body)
                roleUpdate(body).then(res => {
                  console.log(res)
                  this.$message({
                    message: '修改成功!',
                    type: 'success',
                    center: 'true',
                    duration: '1000'
                  })
                  this.handleSearch()
                  this.showAdd = false
                }).catch(err => {
                  console.log(err)
                })
              }
            }
          }
        }
      }
    },
    showInfo: function (data) {
      console.log(data)
      this.item.pid = data.id
    },
    showDropInfo: function (data) {
      console.log(data)
      this.item.deptid = data.id === -1 ? '' : data.id
    },
    handleSearch: function (click) {
      if (click) {
        this.page = 1
      }
      console.log(this.search)
      this.loading = true
      let body = {
        keywork: this.search.value,
        page: this.page,
        rows: this.rows
      }
      console.log(body)
      roleList(body).then(res => {
        console.log(res)
        res.data.rows.map(item => {
          item.sign = 0
        })
        this.tableData = res.data.rows
        this.total = res.data.total
        this.loading = false
        this.all = false
        this.idList = []
      }).catch(err => {
        console.log(err)
      })
    },
    firstPage: function () {
      console.log('首页')
      if (this.page === 1) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        this.page = 1
        this.handleSearch()
      }
    },
    previousPage: function () {
      console.log('上一页')
      if (this.page < 2) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        this.page--
        this.handleSearch()
      }
    },
    nextPage: function () {
      console.log('下一页')
      if (parseInt(this.total / this.rows) + 1 > this.page) {
        this.page++
        this.handleSearch()
      } else {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: 'this.rows00'
        })
      }
    },
    lastPage: function () {
      console.log('尾页')
      if (this.page === parseInt(this.total / this.rows) + 1) {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: 'this.rows00'
        })
      } else {
        if (Math.round(this.total % this.rows) === 0) {
          this.page = parseInt(this.total / this.rows)
        } else {
          this.page = parseInt(this.total / this.rows) + 1
        }
        this.handleSearch()
      }
    }
  }
}
</script>

<style scoped>
@import "System.css";
  .el-checkbox{
    color: #fff !important;
  }
</style>



// WEBPACK FOOTER //
// src/page/system/Role.vue